













































































































































































































import Vue from 'vue'
import { Configuration, ConferenceDetail, ConferenceDetailRestControllerApi } from '@/types/api-docs'
import Utils from "@/utils/utils";

const conferenceApi = new ConferenceDetailRestControllerApi(
  new Configuration({ basePath: `${window.location.origin}` })
)

export type DataType = {
  pageName: string
  breadcrumbs: unknown[]
  conference?: ConferenceDetail
}

export default Vue.extend({
  data(): DataType {
    return {
      pageName: Utils.replaceOrganization(Utils.switchOrganization(this.$store.getters.organization, '学会', '組織'), this.$route.meta.title),
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: Utils.replaceOrganization(Utils.switchOrganization(this.$store.getters.organization, '学会', '組織'), this.$route.meta.title),
          disabled: true,
        },
      ],
      conference: undefined,
    }
  },
  async mounted() {
    await this.fetchConference()
  },
  methods: {
    async fetchConference() {
      const { data } = await conferenceApi.fetchConference()
      this.conference = data
    },
  },
})
